export const dark = {
  blue: '#0050b9',
  blueActive: '#0069f2',
  blueMuted: '#012452',
  text: '#ffffff',
}

export const bright = {
  blue: '#0050b9',
  blueActive: '#0069f2',
  blueMuted: '#0069f2',
  text: '#333333',
}